import { Big, Float } from "./helper";
import { calculateItemRow, calculateTax } from "./calculateItemRow";

// Calculate amount, discount_amount and tax_amount for bundle
// which is the sum of its children
export function calculateBundleRow(item, taxMode, taxCodes) {
    const parentQuantityB = Big(item.quantity); // aka bundle quantity
    let amountB = Big(0);
    let unitPriceB = Big(0);
    let discountAmountB = Big(0);
    let taxAmountB = Big(0);

    let salesTaxAmountB = Big(0);
    let serviceTaxAmount6B = Big(0);
    let serviceTaxAmount8B = Big(0);
    let serviceTaxExemptedAmountB = Big(0);
    let serviceTaxExemptedC1B = Big(0);
    let serviceTaxExemptedC2B = Big(0);
    let serviceTaxExemptedC3B = Big(0);

    let children = [...item?.children || []];

    children = children.map(child => {
        let newChild = child;

        if (child.quantity === "" || child.quantity === null || child.quantity === undefined)
            newChild = { ...newChild, quantity: 1, changedQuantity: true };

        newChild = calculateItemRow(newChild, taxMode, taxCodes);

        // --- Step 1. Calculate child amount = (parentQty * childQty * childUnitPrice), rounded to 2 dp
        // Later, the bundle's total amount (at parent level) = sum of children amount which are in 2 dp
        const childTotalAmountUnroundedB = Big(newChild.amountUnrounded).times(parentQuantityB);
        const childTotalAmountRoundedB = childTotalAmountUnroundedB.round(2);
        amountB = amountB.add(childTotalAmountRoundedB);
        unitPriceB = unitPriceB.add(new Big(newChild.amountUnrounded));

        // --- Step 2. Calculate child discount:
        // a) if discount is %, child discount = [(parentQty * childQty * childUnitPrice), rounded 2 dp ] * childDiscount %, rounded 2 dp
        // b) if discount is float, child discount = (parentQty * childDiscountFloat), rounded 2 dp
        // Bundle's total discount (at parent level) = sum of children discount which are in 2 dp
        let childTotalDiscountB = Big(0);
        if (child.discount) {
            const discountFloat = Float(child.discount);

            if (child.discount.indexOf('%') !== -1) { // Percentage
                childTotalDiscountB = childTotalAmountRoundedB.round(2) // total child amount, rounded
                    .times(Big(discountFloat).div(100)) // * discount %
                    .round(2); // rounded
            }
            else { // Float
                childTotalDiscountB = parentQuantityB // total qty
                    .times(Big(discountFloat)) // * discount
                    .round(2); // rounded
            }
            discountAmountB = discountAmountB.add(childTotalDiscountB);
        }

        // --- Step 3. Calculate child tax:
        // Similarly, to use rounded amount and discount with parentQty * childQty for tax calculation
        const {
            taxAmountB: retTaxAmountB, // rounded
            // taxSystem,
            // isServiceTaxExempted,
            tax_amount_breakdown,
        } = calculateTax(
            newChild,
            childTotalAmountRoundedB, // rounded
            childTotalDiscountB, // rounded
            taxCodes,
            taxMode,
        );
        taxAmountB = taxAmountB.add(Big(retTaxAmountB));

        if (newChild.changedQuantity) {
            newChild.quantity = null;
            newChild.changedQuantity = false;
        }

        // details of taxAmount - breakdown
        const {
            sales_tax_amount,
            service_tax, // Object: { rate, amount }
            service_tax_exempted_amount,
        } = tax_amount_breakdown;
        salesTaxAmountB = salesTaxAmountB.add(Big(sales_tax_amount).round(2));

        // Service Tax (6% or 8%)
        if (service_tax?.rate === 6)
            serviceTaxAmount6B = serviceTaxAmount6B.add(Big(service_tax?.amount).round(2));
        else if (service_tax?.rate === 8)
            serviceTaxAmount8B = serviceTaxAmount8B.add(Big(service_tax?.amount).round(2));

        // Service Tax Exempted (categorized by child tax_code)
        if (newChild.tax_code === 'SVE8C1' || newChild.tax_code === 'SVEC1') {
            serviceTaxExemptedC1B = serviceTaxExemptedC1B.add(Big(service_tax_exempted_amount).round(2));
        }
        else if (newChild.tax_code === 'SVE8C2' || newChild.tax_code === 'SVEC2') {
            serviceTaxExemptedC2B = serviceTaxExemptedC2B.add(Big(service_tax_exempted_amount).round(2));
        }
        else if (newChild.tax_code === 'SVE8C3' || newChild.tax_code === 'SVEC3' || newChild.tax_code === 'SV6E2') {
            serviceTaxExemptedC3B = serviceTaxExemptedC3B.add(Big(service_tax_exempted_amount).round(2));
        }
        else {
            serviceTaxExemptedAmountB =
                serviceTaxExemptedAmountB.add(Big(service_tax_exempted_amount).round(2));
        }

        return newChild;
    });

    // const unitPriceB = amountB.div(parentQuantityB);

    amountB = amountB.round(2);
    discountAmountB = discountAmountB.round(2);

    taxAmountB = taxAmountB.round(2);
    salesTaxAmountB = salesTaxAmountB.round(2);
    serviceTaxAmount6B = serviceTaxAmount6B.round(2);
    serviceTaxAmount8B = serviceTaxAmount8B.round(2);
    serviceTaxExemptedAmountB = serviceTaxExemptedAmountB.round(2);
    serviceTaxExemptedC1B = serviceTaxExemptedC1B.round(2);
    serviceTaxExemptedC2B = serviceTaxExemptedC2B.round(2);
    serviceTaxExemptedC3B = serviceTaxExemptedC3B.round(2);

    // amountB = amountB.times(quantityB).round(2);
    // discountAmountB = discountAmountB.times(quantityB).round(2);
    // taxAmountB = taxAmountB.times(quantityB).round(2);
    // salesTaxAmountB = salesTaxAmountB.times(quantityB).round(2);
    // serviceTaxAmount6B = serviceTaxAmount6B.times(quantityB).round(2);
    // serviceTaxAmount8B = serviceTaxAmount8B.times(quantityB).round(2);
    // serviceTaxExemptedAmountB = serviceTaxExemptedAmountB.times(quantityB).round(2);

    return {
        ...item,
        amount: Float(amountB),
        unit_price: Float(unitPriceB),
        discount_amount: Float(discountAmountB),
        tax_amount: Float(taxAmountB),
        tax_amount_breakdown: {
            sales_tax_amount: Float(salesTaxAmountB),
            // service_tax_amount: Float(serviceTaxAmountB),
            service_tax: [
                { rate: 6, amount: Float(serviceTaxAmount6B) },
                { rate: 8, amount: Float(serviceTaxAmount8B) },
            ],

            service_tax_exempted_amount: Float(serviceTaxExemptedAmountB),
            service_tax_exempted_c1_amount: Float(serviceTaxExemptedC1B),
            service_tax_exempted_c2_amount: Float(serviceTaxExemptedC2B),
            service_tax_exempted_c3_amount: Float(serviceTaxExemptedC3B),
        },
        children,
    };
}
